export enum OnboardingStepType {
  PERSONAL_INFO = 0,
  WORKSPACE_SETTINGS = 1,
  CHANNEL_CREATION = 2,
  OPERATORS_INVITATION = 3,
  BILLING = 4,
}

export default OnboardingStepType;